export const myralisTokens = {
  colors: {
    primary: '#006DFF',
    white: '#FFFFFF',
    institutionalBlue: '#08447E',
    lavender: '#A6B3FF',
    coral: '#FF5429',
    green: '#9FFF88',
    text: '#06264D',
    textMuted: '#61738C',
    surface: '#FFFFFF',
    surfaceMuted: '#F3F8FF',
    surfaceSoft: '#EAF4FF',
    border: '#D7E7FA',
    focus: '#A6B3FF',
    warningSurface: '#FFF3EC',
    warningBorder: '#FFD2C5',
    sidebar: '#071A2F',
    sidebarHover: '#0B2542',
    sidebarActive: '#0F3A66',
  },
  typography: {
    heading: "'Ubuntu', Arial, sans-serif",
    body: "'Barlow', Arial, sans-serif",
  },
  shape: {
    radiusSmall: '8px',
    radiusMedium: '10px',
    radiusPill: '999px',
  },
  shadow: {
    subtle: '0 12px 28px rgba(8, 68, 126, 0.10)',
    floating: '0 18px 40px rgba(8, 68, 126, 0.16)',
  },
} as const;

export type MyralisThemeTokens = typeof myralisTokens;
